import type { PageLoad } from "./$types";

export const prerender = true;

export const load: PageLoad = () => {
  return {
    title: "Fine Tuning | Modal",
    ogTitle: "Fine Tuning on Modal",
    ogDescription:
      "How to run fine-tune large language models on Modal, a serverless compute platform.",
  };
};
